import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-primary",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printInvoice && _ctx.printInvoice(...args)))
  }, "Print"))
}